import { axiosUtil as Api } from "../utils/axios";
import CONFIG from "../utils/config";

// const defaultTime = 5000;
const endpoint = CONFIG.VUE_APP_SERVICE_USER_PRIVATE

export const UserApi = Object.freeze({
    getMemberActivity: (days = 90, page = 1, perPage = 50) => Api.get(endpoint + '/member-activity', { params: { days, page, per_page: perPage } }),
    getAll: (
        perPage,
        page,
        search
    ) => search ? Api.get(endpoint + '/user?per_page=' + perPage + '&page=' + page + '&name=' + search + '&email=' + search + '&uuid=' + search) : Api.get(endpoint + '/user?per_page=' + perPage + '&page=' + page),

    detail: (
        id
    ) => Api.get(endpoint + '/user/' + id + '/show'),

    updateUser: (
        id,
        payload
    ) => Api.put(endpoint + '/user/' + id, payload),

    getMe: () => {
        Api.get(endpoint + '/me')
    },

    addMentor: (
        payload
    ) => Api.post(endpoint + '/mentor', payload),

    getMentorList: () => {
        const res = Api.get(endpoint + '/mentor?per_page=1000000')

        return Promise.resolve(res)
    },
    getUserReport: (startDate = null, endDate = null) => (
        Api.get(`${endpoint}/report`, {
            params: {
                start_date: startDate,
                end_date: endDate
            }
        })
    ),
    removeMentor: (id) => {
        try {
            const res = Api.delete(endpoint + '/mentor/' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    listAdmin: (perPage, page) => {
        try {
            const res = Api.get(endpoint + '/admin?per_page=' + perPage + '&page=' + page)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addAdmin: (
        payload
    ) => {
        try {
            const data = {
                uuid: payload.uuid,
                category: parseInt(payload.category),
                expired_at: payload.expiredAt,
                admin_type_id: parseInt(payload.adminTypeId)
            }
            const res = Api.post(endpoint + '/admin', data)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updateAdmin: (
        payload
    ) => {
        try {
            const data = {
                uuid: payload.uuid,
                category: parseInt(payload.category),
                expired_at: payload.expiredAt,
                admin_type_id: parseInt(payload.adminTypeId)
            }
            console.log(data)
            const res = Api.put(endpoint + '/admin/' + payload.id, data)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    detailAdmin: (id) => {
        try {
            const res = Api.get(endpoint + '/admin/' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    editAdmin: (payload) => {
        try {
            const data = {
                uuid: payload.data.uuid,
                category: parseInt(payload.data.categoryId),
                expired_at: payload.data.expiredAt
            }
            const res = Api.put(endpoint + '/admin/' + payload.id, data)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    removeAdmin: (id) => {
        try {
            const res = Api.delete(endpoint + '/admin/' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    searchListUser: (query) => {
        try {
            const search = query.search
            const per_page = query.per_page
            const page = query.page
            let url = endpoint + '/user'
            if (search !== '') {
                url = url + '?name=' + search + '&email=' + search + '&uuid=' + search + '&page=' + page + '&per_page=' + per_page
            }
            const res = Api.get(url)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    searchUserByEmail: (email) => {
        try {
            const res = Api.get(endpoint + '/email?email=' + email)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    }
});